export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6632.e6bf5e55.jpg";